import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetInstructionDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Instruction/GetDetail?` + params, null);

export const GetInstructionList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Instruction/GetList?` + params, null);

export const GetInvestigationInstructionListForSelect = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Instruction/GetListForSelect?` + params, null);

export const GetInvestigationInstructionList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/InvestigationInstruction/GetList?` + params, null);

export const CreateInstruction = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Instruction/Create`, data);

export const UpdateInstruction = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Instruction/Update`, data);    

export const DeleteInstruction = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Instruction/Delete`, data);

export const DeleteInvestigationInstruction = (data: any) =>
  POST_ENC(`${BASE_URL}/api/InvestigationInstruction/Delete`, data);
